import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';

import store from '@/store';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      redirect: { name: 'authorizedPersonsPage' },
      children: [
        {
          path: '/service-management/authorized-persons',
          name: 'authorizedPersonsPage',
          component: () => import(/* webpackChunkName:"authorizedPersons" */ './views/serviceManagement/authorizedPersonsPage.vue'),
          meta: {
            title: '授权人列表',
          },
        },
        {
          path: '/service-management/template-list/:user_id',
          name: 'templateList',
          component: () => import(/* webpackChunkName:"authorizedPersons" */ './views/serviceManagement/TemplateList.vue'),
          meta: {
            title: '服务管理',
            breadcrumb: [{
              title: '授权人列表',
              path: '/service-management/authorized-persons',
            }],
          },
        },
        {
          path: '/service-management/user-report/:user_id/:template_id',
          name: 'userReport',
          component: () => import(/* webpackChunkName:"authorizedPersons" */ './views/serviceManagement/UserReport.vue'),
          meta: {
            title: '服务项目',
            breadcrumb: [{
              title: '授权人列表',
              path: '/service-management/authorized-persons',
            },
            {
              title: '服务管理',
              path: '/service-management/template-list/:user_id',
            }],
          },
        },
        {
          path: '/service-management/report-export/:user_id/:template_id',
          name: 'reportExport',
          component: () => import(/* webpackChunkName:"authorizedPersons" */ './views/serviceManagement/ReportExport.vue'),
          meta: {
            title: '项目报告导出',
            breadcrumb: [{
              title: '授权人列表',
              path: '/service-management/authorized-persons',
            },
            {
              title: '服务管理',
              path: '/service-management/template-list/:user_id',
            }],
          },
        },
        {
          path: '/service-management/export-list/:user_id/:template_id',
          name: 'exportList',
          component: () => import(/* webpackChunkName:"authorizedPersons" */ './views/serviceManagement/ExportList.vue'),
          meta: {
            title: '项目报告导出列表',
            breadcrumb: [{
              title: '授权人列表',
              path: '/service-management/authorized-persons',
            },
            {
              title: '服务管理',
              path: '/service-management/template-list/:user_id',
            },
            {
              title: '项目报告导出',
              path: '/service-management/report-export/:user_id/:template_id',
            },
            ],
          },
        },
      ],
    },
    {
      path: '/retrieve-password/:type',
      name: 'RetrieveThePassword',
      component: () => import(/* webpackChunkName:"RetrieveThePassword" */ './views/RetrieveThePassword.vue'),
      meta: { title: '找回密码' },
    },
    {
      path: '/buy',
      name: 'buy',
      component: () => import(/* webpackChunkName: "buy" */ './views/Buy.vue'),
    },
  ],
});

Router.prototype.windowOpen = function (param) {
  if (param && Object.prototype.toString.call(param) === '[object Object]') {
    const route = router.resolve(param);
    window.open(route.href);
  }
};

router.beforeEach((to, from, next) => {
  const reg = /\/:[\w]*/ig;
  const meta = JSON.parse(JSON.stringify(to.meta));
  if (meta.breadcrumb && meta.breadcrumb.length > 0) {
    const { breadcrumb } = meta;
    for (const item of breadcrumb) {
      if (reg.test(item.path)) {
        const params = item.path.match(reg);
        for (const item2 of params) {
          const p = item2.replace('/:', '');
          if (from.params.hasOwnProperty(p)) {
            item.path = item.path.replace(item2, `/${from.params[p]}`);
          } else if (to.params.hasOwnProperty(p)) {
            item.path = item.path.replace(item2, `/${to.params[p]}`);
          }
        }
      }
    }
  }

  if(['项目报告导出','项目报告导出列表'].indexOf(meta.title)>=0&&to.params.user_id==-1){
    let breadcrumb=[]
    meta.breadcrumb.forEach(item=>{
      if(item.title!='服务管理'){
        breadcrumb.push(item);
      }
    })
    meta.breadcrumb=breadcrumb
  }

  store.commit('setMeta', meta);
  next();
});

export default router;
